import React from 'react'
import Hero from './Component/Hero'
import AboutContent from './Component/AboutContent'
import Stats from './Component/Stats'
import Values from './Component/Values'
import Offices from './Component/Offices'
import Investors from './Component/Investors'
import CTA from './Component/CTA'


function About() {
  return (
    <>
      <Hero />
      <AboutContent />
      <div className="section-spacer"></div>
      <Stats />
      <div className="section-spacer"></div>
      <Values />
      <div className="section-spacer"></div>
      <Offices />
      <div className="section-spacer"></div>
      <Investors />
      <div className="section-spacer"></div>
      <CTA />
      <div className="section-spacer"></div>
    </>
  )
}

export default About